// @flow
import React from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { createStructuredSelector } from "reselect";
import t from "common/i18n";
import {
	selectFiltersPanelOpen,
	selectCategories,
	selectCurrentContext,
	selectSort,
} from "../../selectors";
import ContextItems from "../ContextItems";
import { getSelectedItem } from "../FiltersPanel/SortBy";

import type { Category } from "../../data/types";

import "./SelectionPage.scss";

type Props = {
	doSearch: Function,
	onSelect: Function,
	isFiltersPanelOpen: boolean,
	currentContext: { context: number },
	categories: Category[],
	sort: string,
};

export const SelectionPage = (props: Props) => {
	const {
		isFiltersPanelOpen,
		currentContext,
		categories,
	} = props;

	const handleCategoryClick = (value: string) => {
		props.doSearch({ filters: { category: value } });
	};

	return <div
		className={cx("stage flex overflow-y-auto relative selection-page overlay-prevent-pointer-events", { "filter-panel-open": isFiltersPanelOpen })}>
		<div className="h-100 w-100 overflow-auto">
			<h2 className="mb6 ml3 mt6 bg-source-bg-c">{getSelectedItem(props.sort).label}</h2>
			<div className="items-container-short mb4">
				<ContextItems
					onSelect={props.onSelect}
					context={currentContext}
					isFiltersPanelOpen={isFiltersPanelOpen}/>
			</div>
			<h2 className="mb4 ml3 bg-source-bg-c">{t("shutterstock.home_page.categories_header")}</h2>
			<ul className="pl0 mr0 ml0 mt0 mb6 list flex flex-row flex-wrap category-list">
				{categories.map((category) => (
					<li key={category.value}
					    onClick={() => handleCategoryClick(category.value)}
					    className={cx("bg-source-bg-c", {
						    dn: category.value === "all", // hide the all categories option because we are already in it
					    })}>
						{category.label}
					</li>
				))}
			</ul>
		</div>
	</div>;
};

export default connect<Props, *, *, *, *, *>(
	createStructuredSelector({
		currentContext: selectCurrentContext,
		isFiltersPanelOpen: selectFiltersPanelOpen,
		categories: selectCategories,
		sort: selectSort,
	}),
)(SelectionPage);
